// extracted by mini-css-extract-plugin
module.exports = {"avatarGroup":"styles_avatarGroup__sA9KZ","topAvatar":"styles_topAvatar__9j3xu"};